import { Annotation } from '../types';

export function getLocalStorageItemId(id: string) {
  return `alma-vkh-annotations-${id}`;
}

export async function fetchAnnotations(id: string): Promise<Annotation[]> {
  const annotations = localStorage.getItem(getLocalStorageItemId(id));
  if (annotations) {
    return JSON.parse(annotations);
  }
  return [];
}
